// Social screens' copy in Portuguese (the Dutch in lib/social/copy.ts is the source), in our own words.
export const socialHubPt = {
  "social.about.section.account": "Conta",
  "social.about.sync.title": "Leva as tuas notas contigo",
  "social.about.sync.action": "Iniciar sessão",
  "social.about.sync.manage": "Gerir",
  "social.about.sync.signedInAs": "Sessão iniciada como {email}",
  "social.about.sync.unconfirmed":
    "Não conseguimos verificar a tua conta agora; manténs a sessão iniciada e voltamos a tentar daqui a pouco.",
  "social.signin.gate.title": "Inicia sessão para provar em conjunto",
  "social.signin.gate.body":
    "Amigos, grupos e provas estão ligados a uma conta. As notas neste dispositivo continuam a ser só tuas.",
  "social.signin.gate.action": "Iniciar sessão",
  "social.about.public.label": "Contactável por mensagens a 'todos'",
  "social.about.public.hint":
    "Ativa isto para que amigos fora dos teus grupos te possam contactar com uma mensagem a 'todos' numa prova. Isto só define quem te pode enviar mensagens para todos, não se apareces nos resultados de pesquisa — isso define-se em 'Os outros podem encontrar-te'.",
  "social.about.discoverable.label": "Os outros podem encontrar-te",
  "social.about.discoverable.hint":
    "O teu nome de utilizador e o teu nome aparecem na pesquisa dos outros utilizadores. Desativa para não seres encontrado.",
  "social.signin.title": "Iniciar sessão",
  "social.signin.subtitle": "Escolhe como queres iniciar sessão",
  "social.signin.provider.google": "Google",
  "social.signin.provider.microsoft": "Microsoft",
  "social.signin.provider.instagram": "Instagram",
  "social.signin.provider.tiktok": "TikTok",
  "social.signin.provider.pending": "Ainda não disponível — em análise pelo fornecedor",
  "social.signin.error.denied": "O início de sessão foi cancelado ou recusado.",
  "social.signin.error.generic": "Não foi possível iniciar sessão. Tenta de novo.",
  "social.signin.success.title": "Sessão iniciada",
  "social.friends.title": "Amigos",
  "social.friends.empty.title": "ainda sem amigos",
  "social.friends.empty.body": "Adiciona um amigo para provarem em conjunto.",
  "social.friends.empty.action": "Adicionar amigo",
  "social.friends.incoming.title": "Pedidos",
  "social.friends.incoming.accept": "Aceitar",
  "social.friends.incoming.decline": "Recusar",
  "social.friends.outgoing.label": "Pedido enviado",
  "social.friends.outgoing.cancel": "Cancelar pedido",
  "social.friends.row.block": "Bloquear",
  "social.friends.row.unblock": "Desbloquear",
  "social.friends.row.remove": "Remover",
  "social.friends.accepted.toast": "Agora são amigos",
  "social.friends.add.title": "Adicionar amigo",
  "social.friends.add.searchPlaceholder": "Nome ou nome de utilizador",
  "social.friends.add.send": "Enviar pedido",
  "social.friends.add.queued": "Envia assim que voltares a estar online",
  "social.friends.add.sent": "Enviado",
  "social.friends.add.noResults": "Sem resultados",
  "social.friends.add.action": "Adicionar",
  "social.friends.search.resultCount": "{n} resultados",
  "social.groups.title": "Grupos",
  "social.groups.empty.title": "ainda sem grupos",
  "social.groups.empty.body": "Cria um grupo para provarem em conjunto.",
  "social.groups.empty.action": "Criar grupo",
  "social.groups.memberCount": "{n} membros",
  "social.groups.role.owner": "proprietário",
  "social.groups.role.admin": "administrador",
  "social.groups.role.member": "membro",
  "social.groups.create.title": "Criar grupo",
  "social.groups.create.name": "Nome",
  "social.groups.create.description": "Descrição (opcional)",
  "social.groups.create.confirm": "Criar",
  "social.groups.edit.title": "Editar grupo",
  "social.groups.edit.confirm": "Guardar",
  "social.groups.avatar.upload": "Escolher foto",
  "social.groups.avatar.uploading": "A carregar…",
  "social.groups.avatar.remove": "Remover foto",
  "social.groups.visibility.label": "Quem pode ver este grupo",
  "social.groups.visibility.membersAndInvitees": "Visível para membros e convidados",
  "social.groups.visibility.membersOnly": "Só membros, sem pré-visualização da ligação",
  "social.groups.visibility.discoverable": "Listado no diretório de grupos",
  "social.groups.directory.entry": "Procurar um grupo",
  "social.groups.directory.title": "Procurar um grupo",
  "social.groups.directory.searchPlaceholder": "Nome do grupo",
  "social.groups.directory.noResults": "Nenhum grupo encontrado",
  "social.groups.directory.resultCount": "{n} resultados",
  "social.groups.directory.requestToJoin": "Pedir para entrar",
  "social.groups.directory.requested": "Pedido feito",
  "social.groups.joinRequests.title": "Pedidos de entrada",
  "social.groups.joinRequests.accept": "Aceitar",
  "social.groups.joinRequests.decline": "Recusar",
  "social.groups.invitePermission.label": "Quem pode convidar",
  "social.groups.invitePermission.ownerAdmin": "Só o proprietário e os administradores",
  "social.groups.invitePermission.anyMember": "Qualquer membro",
  "social.groups.detail.editAction": "Editar grupo",
  "social.groups.detail.removeMember": "Remover",
  "social.groups.detail.leave": "Sair do grupo",
  "social.groups.detail.delete": "Eliminar grupo",
  "social.groups.detail.loadMore": "Mostrar mais",
  "social.groups.detail.zeroOwnerLeaveBlocked":
    "Transfere primeiro a propriedade ou elimina o grupo",
  "social.groups.invite.title": "Convidar",
  "social.groups.invite.noFriends": "Não há amigos para convidar.",
  "social.session.title": "Prova",
  "social.session.draft.nameLabel": "Nome",
  "social.session.draft.invite": "Convidar",
  "social.session.draft.startNow": "Começar agora",
  "social.session.scheduled.label": "Marcada para {date}",
  "social.session.action.schedule": "Marcar",
  "social.session.action.start": "Começar",
  "social.session.action.cancel": "Cancelar",
  "social.session.action.end": "Terminar",
  "social.session.status.invited": "convidado",
  "social.session.status.joined": "entrou",
  "social.session.status.online": "online",
  "social.session.status.offline": "offline",
  "social.session.status.live": "Ao vivo",
  "social.session.ended.title": "Terminada",
  "social.session.ended.toast": "esta prova terminou",
  "social.session.reconnecting": "A voltar a ligar…",
  "social.session.presenceCount": "{n} online",
  "social.session.schedule.date": "Data (opcional)",
  "social.session.schedule.time": "Hora (opcional)",
  "social.session.schedule.invalid": "Escolhe uma data e uma hora no futuro.",
  "social.session.invite.title": "Convidar participantes",
  "social.session.invite.confirm": "Convidar",
  "social.session.invite.sourceFriends": "Amigos",
  "social.session.invite.sourceGroup": "Grupo",
  "social.broadcast.composer.title": "Enviar uma mensagem",
  "social.broadcast.composer.targetFriends": "Amigos",
  "social.broadcast.composer.targetGroup": "Grupo",
  "social.broadcast.composer.targetEveryone": "Todos nesta prova",
  "social.broadcast.composer.textPlaceholder": "A tua mensagem…",
  "social.broadcast.composer.send": "Enviar",
  "social.broadcast.composer.queued": "Envia assim que voltares a estar online",
  "social.broadcast.composer.sent": "Enviada",
  "social.broadcast.composer.sentPartial": "Enviada, {n} não entregues",
  "social.broadcast.panel.title": "Dirigido a ti nesta prova",
  "social.broadcast.panel.empty": "Ainda nada dirigido a ti nesta prova",
  "social.presence.online": "online",
  "social.presence.offline": "offline",
  "social.invite.friends.action": "Convidar",
  "social.invite.friends.title": "Convidar amigos",
  "social.invite.friends.lead":
    "Envia a tua ligação pessoal. Quem a abrir e iniciar sessão torna-se teu amigo.",
  "social.invite.group.title": "Convidar para {group}",
  "social.invite.group.lead": "Quem abrir a ligação ou escrever o código entra no grupo.",
  "social.invite.channel.whatsapp": "WhatsApp",
  "social.invite.channel.email": "E-mail",
  "social.invite.channel.sms": "SMS",
  "social.invite.channel.copy": "Copiar ligação",
  "social.invite.channel.copied": "Ligação copiada",
  "social.invite.qr.label": "Código QR com o convite",
  "social.invite.code.label": "Ou diz este código",
  "social.invite.code.until": "Válido até {time}",
  "social.invite.status": "Restam {left} de {max} utilizações, válido até {date}",
  "social.invite.audience.one": "Uma pessoa",
  "social.invite.audience.many": "Até 10 pessoas",
  "social.invite.audience.manyHint": "Com mais pessoas, confirmas tu cada pedido.",
  "social.invite.approval.label": "Aprovar primeiro os novos membros",
  "social.invite.joined.title": "Quem entrou",
  "social.invite.revoke": "Revogar ligação",
  "social.invite.revoked": "Esta ligação já não funciona.",
  "social.invite.renew": "Criar nova ligação",
  "social.invite.landing.title": "Convite",
  "social.invite.landing.friend": "{name} convida-te para provarem em conjunto.",
  "social.invite.landing.group": "{name} convida-te para {group}.",
  "social.invite.landing.groupHidden": "{name} convida-te para um grupo.",
  "social.invite.landing.approval": "Um administrador aprova o teu pedido.",
  "social.invite.landing.expires": "Válido até {date}",
  "social.invite.landing.accept": "Aceitar",
  "social.invite.landing.decline": "Não, obrigado",
  "social.invite.landing.signIn": "Inicia sessão para aceitar",
  "social.invite.landing.gone.title": "Este convite já não funciona",
  "social.invite.landing.gone.body": "Pede uma nova ligação ou um novo código.",
  "social.invite.landing.none.title": "Nenhum convite encontrado",
  "social.invite.landing.none.body": "Abre a ligação outra vez ou escreve o código.",
  "social.invite.outcome.friends": "Agora são amigos",
  "social.invite.outcome.requested": "Pedido enviado. {name} vai confirmá-lo.",
  "social.invite.outcome.joined": "Entraste no grupo",
  "social.invite.outcome.joinRequested": "Pedido enviado. Um administrador vai aprová-lo.",
  "social.invite.outcome.toFriends": "Ir para os amigos",
  "social.invite.outcome.toGroup": "Ir para o grupo",
  "social.code.action": "Tens um código?",
  "social.code.title": "Escrever um código",
  "social.code.hint": "Três palavras para um convite, seis para uma prova.",
  "social.code.placeholder": "ex.: leaf lime loft",
  "social.code.submit": "Continuar",
  "social.code.invalid": "Isso não é um código. Confere outra vez as palavras.",
  "social.samen.title": "Juntos",
  "social.samen.badge": "{label}, {count} novos",
  "social.samen.announce": "{count} novos em Juntos",
  "social.samen.profile": "O teu perfil",
  "social.samen.lead": "Os teus amigos, os teus grupos e o que te espera.",
  "social.inbox.title": "Caixa de entrada",
  "social.inbox.tab.received": "Recebidos",
  "social.inbox.tab.sent": "Enviados",
  "social.inbox.tab.updates": "Novidades",
  "social.inbox.empty.received": "Não há nada à tua espera.",
  "social.inbox.empty.sent": "Não estás à espera de ninguém.",
  "social.inbox.empty.updates": "Ainda sem novidades.",
  "social.inbox.friendRequest": "quer ser teu amigo",
  "social.inbox.groupInvite": "{name} convida-te para {group}",
  "social.inbox.groupInviteAnonymous": "Convite para {group}",
  "social.inbox.joinRequest": "quer entrar em {group}",
  "social.inbox.sessionInvite": "{name} convida-te para {session}",
  "social.inbox.accept": "Aceitar",
  "social.inbox.decline": "Recusar",
  "social.inbox.open": "Ver",
  "social.inbox.cancel": "Retirar",
  "social.inbox.remind": "Lembrar",
  "social.inbox.reminded": "Lembrado",
  "social.inbox.sent.friendRequest": "Pedido de amizade",
  "social.inbox.sent.groupInvite": "Convidado para {group}",
  "social.inbox.links.title": "As tuas ligações",
  "social.inbox.link.friend": "Ligação pessoal",
  "social.inbox.link.group": "Ligação para {group}",
  "social.inbox.link.ended": "Já não funciona",
  "social.inbox.link.joined": "Entraram: {names}",
  "social.inbox.update.friendAccepted": "{name} é agora teu amigo",
  "social.inbox.update.groupInviteAccepted": "{name} entrou em {group}",
  "social.inbox.update.joinApproved": "Entraste em {group}",
  "social.inbox.someone": "Alguém",
  "social.inbox.aGroup": "um grupo",
  "social.inbox.queued": "Segue assim que voltares a estar online",
  "social.profile.title": "Perfil",
  "social.profile.lead": "É assim que os outros te veem.",
  "social.profile.noGroups": "Ainda não estás em nenhum grupo.",
  "social.profile.signedOut": "Inicia sessão para teres um perfil que os teus amigos veem.",
  "social.settings.title": "Definições",
  "social.settings.open": "Abrir definições",
  "social.notify.title": "Notificações",
  "social.notify.invites": "Convites e pedidos",
  "social.notify.invites.hint":
    "Uma notificação quando alguém te convida ou quer ser teu amigo. Quem aceitou aparece na tua caixa de entrada.",
  "social.notify.quiet": "Horas de silêncio",
  "social.notify.quiet.from": "Das",
  "social.notify.quiet.until": "Até às",
  "social.notify.quiet.hint":
    "Nestas horas não há notificações; tudo continua na tua caixa de entrada. No máximo {n} notificações por dia.",
  "social.notify.mutes.title": "Silenciados",
  "social.notify.mutes.empty":
    "Ninguém silenciado. Um amigo ou grupo silenciado deixa de te enviar notificações.",
  "social.notify.mute": "Silenciar",
  "social.notify.unmute": "Deixar de silenciar",
  "social.groups.inviteFriends": "Convidar amigos",
  "social.groups.inviteFriends.sent": "{n} convidados. Entram assim que aceitarem.",
  "social.groups.inviteLink": "Partilhar uma ligação",
  "social.groups.log.title": "Registo",
  "social.groups.log.empty": "Ainda não aconteceu nada.",
  "social.groups.log.created": "{name} criou o grupo",
  "social.groups.log.joined": "{name} entrou",
  "social.groups.log.left": "{name} saiu do grupo",
  "social.groups.log.removed": "{name} foi removido do grupo",
  "social.groups.log.role": "{name} é agora {role}",
  "social.groups.mute": "Silenciar grupo",
  "social.groups.unmute": "Deixar de silenciar o grupo",
  "social.share.title": "Partilhar",
  "social.share.action": "Partilhar",
  "social.share.shared": "Partilhado",
  "social.share.copied": "Ligação copiada",
  "social.invite.channel.share": "Partilhar…",
  "social.inbox.link.reshare": "Partilhar de novo",
} as const;
